import { CreateAccommodationRoomModal } from "Bands/containers/CreateAccommodationBlockForm/CreateAccommodationRoomModal";
import { FC, useState } from "react";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { Button } from "shared/components";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

const { accommodationBlock: blockCopy } = copy;

interface AddAccommodationRoomProps {
  accommodationBlockId: string;
}

export const AddAccommodationRoom: FC<AddAccommodationRoomProps> = ({ accommodationBlockId }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        data-testid={"add_accommodation_room"}
        onClick={() => setShowModal(true)}
        theme={ITheme.secondary}
        size="m"
      >
        <Icon as={Plus} /> {" " + blockCopy.create.roomsBlock.fields.title}
      </Button>
      {showModal && (
        <CreateAccommodationRoomModal
          accommodationBlockId={accommodationBlockId}
          handleClose={() => setShowModal(false)}
        ></CreateAccommodationRoomModal>
      )}
    </>
  );
};
